module.exports = __webpack_public_path__ + "static/media/ceo_title_english.f8bfb8df.png";